import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from '../components/ui/alert';
import { supabase } from '../lib/supabase';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    const finish = async () => {
      const params = new URLSearchParams(window.location.search);
      const callbackError = params.get('error_description') || params.get('error');
      if (callbackError) throw new Error('This confirmation link is invalid or expired.');
      const { data: existing } = await supabase.auth.getSession();
      if (!existing.session && params.get('code')) {
        const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(window.location.href);
        if (exchangeError) throw exchangeError;
      }
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      if (sessionError || !session) throw new Error('Confirmation did not establish a session. Please sign in.');
      if (active) navigate('/', { replace: true });
    };
    finish().catch(() => active && setError('This confirmation link is invalid or expired. Please request a new email.'));
    return () => { active = false; };
  }, [navigate]);

  return (
    <main className="min-h-screen grid place-items-center bg-background px-4" data-testid="auth-callback-page">
      {error ? (
        <Alert variant="destructive" className="max-w-md" data-testid="auth-callback-error">
          <AlertCircle className="h-4 w-4" /><AlertDescription>{error}</AlertDescription>
        </Alert>
      ) : (
        <div className="flex items-center gap-3 text-muted-foreground" data-testid="auth-callback-loading">
          <Loader2 className="h-5 w-5 animate-spin" />Confirming your email…
        </div>
      )}
    </main>
  );
}